<template>
  <q-btn
    v-if="!currentUserIdNumber"
    @click="navigateToProfilePage"
    unelevated
    no-caps
    color="tertiary"
    :flat="fullBtn"
    :stack="!fullBtn"
    :padding="fullBtn ? 'fullBtn' : '10px 8px'"
    :class="fullBtn ? 'no-hover' : 'full-width'"
  >
    <q-icon name="person" v-if="!fullBtn" />
    My Profile
    <q-icon size="18px" name="launch" class="q-ml-sm" v-if="fullBtn" />
  </q-btn>
</template>

<script>
import { appConfig } from 'src/constants'
import { useAuthStore } from 'src/stores/auth'
import { mapState } from 'pinia'
import { isPWA } from 'src/utils'
import { usePlatform } from 'src/composables/usePlatform'

export default {
  name: 'ProfileLink',
  data() {
    return {
      myProfileUrl: appConfig.MY_PROFILE_URL,
      authStore: useAuthStore(),
    }
  },
  props: {
    className: {
      type: String,
      default: '',
    },
    fullBtn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(useAuthStore, ['currentUserIdNumber']),
    isPWA,
  },
  methods: {
    navigateToProfilePage() {
      const _this = this,
        options = this.isCordova
          ? 'location=no,clearsessioncache=no,clearcache=no,cleardata=no'
          : this.isPWA
          ? 'toolbar=no'
          : ''
      const popupWindow = window.open(this.myProfileUrl, '_blank', options)
      if (this.isCordova)
        popupWindow.addEventListener('exit', function (event) {
          _this.authStore.getUserInfo()
        })
    },
  },
  setup() {
    const { isCordova } = usePlatform()
    return { isCordova }
  },
}
</script>
